var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"form-label",class:{ 'has-error': _vm.hasError }},[_vm._t("default",function(){return [_vm._v("Label")]}),(_vm.isRequired)?_c('span',{staticClass:"form-label__required"},[_vm._v(" *")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }